export const capitalizeFirstLetter = (string) => {
    if (!string) return ''; // vérifie si la chaîne est définie
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }

